export function resetDateSecondsAndMillis(date: Date) {
  date.setUTCSeconds(0);
  date.setUTCMilliseconds(0);
  return date;
}
